<template>
    <div class="yh-page">
      <el-card>
        <el-row slot="header" type="flex" justify="space-between" align="middle" class="p-3" :gutter="10">
          <el-col :span="20">
            <el-input placeholder="输入船东信息进行搜索..." v-model.trim="query.search"
                      @keyup.enter.native="handleSearch">
              <el-button slot="append" icon="el-icon-search" v-loading="searching" @click="handleSearch">搜索</el-button>
            </el-input>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" size="small"  @click="memberQuitApplyExport">会员退会文书</el-button>
          
            </el-col>
        </el-row>
        <div>
          <el-table :key="0" :data="list" stripe v-loading="listLoading" :element-loading-text="loadingText" fit
                    highlight-current-row class="w-100" @selection-change="handleSelectionChange">
            <!-- 客户名称 -->
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column align="left" label="会员名称" min-width="120px">
              <template slot-scope="scope">
                <span v-if="$perm(['customer.view_customer'])" class="font-weight-bold text-link"
                      @click="handleUpdate(scope.row.id)">{{scope.row.name}}</span>
                <span v-else class="font-weight-bold">{{scope.row.name}}</span>
                <span class="badge ml-2" :class="scope.row.type === '0' ? 'badge-success' : 'badge-warning'">{{ scope.row.type_name }}</span>
              </template>
            </el-table-column>
            <!-- 固定电话 -->
            <!-- <el-table-column align="left" label="电话">
              <template slot-scope="scope">
                <span>{{scope.row.phone}}</span>
              </template>
            </el-table-column> -->
            <!-- 手机号码 -->
            <!-- <el-table-column align="left" label="手机">
              <template slot-scope="scope">
                <span>{{scope.row.mobile}}</span>
              </template>
            </el-table-column> -->
            <!-- 邮箱 -->
            <el-table-column align="left" label="邮箱">
              <template slot-scope="scope">
                <span>{{scope.row.email}}</span>
              </template>
            </el-table-column>
            <!-- 更新人 -->
            <el-table-column align="left" label="更新人">
              <template slot-scope="scope">
                <span>{{scope.row.updater_name ? scope.row.updater_name :scope.row.creator_name}}</span>
              </template>
            </el-table-column>
            <!-- 创建时间 -->
            <el-table-column align="left" label="创建时间">
              <template slot-scope="scope">
                <span>{{ scope.row.create_time | parseTime }}</span>
              </template>
            </el-table-column>
            <!-- 数据完整度 -->
            <el-table-column align = "left" label = "数据完整度">
              <template slot-scope = "scope">
                <span :style="{'color': completeness(scope.row)<30? 'red': completeness(scope.row)>70? 'green':'blue'}"> 
                  <!-- 完成率<30%(红色);完成率>70%(绿色);其他(蓝色) -->
                  {{ completeness(scope.row) }}%
                </span>
              </template>
            </el-table-column>
            <!-- 证书识别状态 -->
            <!-- <el-table-column align="left" label="证书状态">
              <template slot-scope="scope">
                <el-popover :disabled="scope.row.cert_status==='0' || scope.row.cert_status==='1'"
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  :content=scope.row.cert_msg>
                  <span class="badge mr-1" :class="getCertStatusBadge(scope.row.cert_status)" slot="reference">{{ scope.row.cert_status_name }}</span>
                </el-popover>
              </template>
            </el-table-column> -->
            <!-- 按钮组 -->
            <el-table-column align="left" label="邮箱">
              <template slot-scope="scope">
                <span>{{scope.row.status === 2 ?"审核中":"已提交审核"}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="操作">
              <template slot-scope="scope">
                <!-- <el-tooltip class="item" effect="light" content="编辑" placement="top-start">
                  <el-button type="text" class="pr-1" @click="handleUpdate(scope.row.id)">
                    <svg-icon icon-class="edit"></svg-icon>
                  </el-button>
                </el-tooltip> -->
                <el-tooltip effect="light" content="提交审核" placement="top-start" v-show="[2].indexOf(scope.row.status) !== -1">
                  <el-button type="text" class="pr-1" @click="handleSubmit(scope.row)">
                    <i class="el-icon-s-promotion"></i>
                  </el-button>
                </el-tooltip>
                <el-tooltip effect="light" content="退会审核" placement="top-start" v-show="[7].indexOf(scope.row.status) !== -1  && $perm(['member.auditing_member_apply'])">
                    <el-button type="text" class="pr-1" @click="handleSuccess(scope.row)">
                        <i class="el-icon-document-checked"></i>
                    </el-button>
                </el-tooltip>
                <el-tooltip effect="light" content="上传" placement="top-start">
                  <el-button type="text" class="pr-1" @click="handleUpload(scope.row)">
                    <i class="el-icon-upload"></i>
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <pagination-new :size.sync="query.limit" :offset.sync="query.offset" :total="total"
                      @updateList="getList"></pagination-new>
          <upload-dialog ref="upload"
              :object-name="object_name"
              :file-type-list="file_type_list"
              object-type="member.member"
              :object-id="apply_id"
              :customer-list="customerList"
              :is-upload="true"
              @uploaded="handleAppended">
          </upload-dialog>
          <el-dialog title="填写签署日期" :visible.sync="dialogVisible">
            <el-form label-position="right" label-width="150px" v-loading="downloading" :element-loading-text="downloadingText">
              <el-row>
                <el-col>
                  <el-form-item label="签署日期">
                    <el-date-picker
                      v-model="write_date"
                      type="date"
                      format="yyyy 年 MM 月 dd 日"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" class="border-top mt-2 pt-3">
                  <el-form-item>
                    <el-button size="small" type="primary" style="float: right" @click="handlePrint">导出</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-dialog>
        </div>
      </el-card>
      <member-upload-cert-dialog ref="CustomerUploadCert">
      </member-upload-cert-dialog>
    </div>
  
  </template>
  
  <script>
    import {parseTime} from '@/utils'
    import PaginationNew from '@/components/PaginationNew'
    import { getCertStatusBadge } from '@/utils/customer'
    import MemberUploadCertDialog from './member-upload-cert-dialog'
    import UploadDialog from "@/components/UploadDialog";
    import { fetchFileTypeList } from "@/api/common"
    import {getMemberList,deleteMember,SubmitQuitApply,exportNotification} from '@/api/member'
  
    export default {
      name: "quitApplyList",
      components: {
        PaginationNew,
        MemberUploadCertDialog,
        UploadDialog
      },
      filters: {
        parseTime
      },
      data() {
        return {
          list:[],
          query: {
            search: '',
            offset: 0,
            limit: 20,
            updater: '',
            type:'QuitApply'
          },
          searching: false,
          listLoading: false,
          loadingText: '正在加载船东数据，请稍等...',
          list: [],
          file_type_list: [],
          customerList:[],
          dialogVisible:false,
          downloading:false,
          downloadingText:false,
          total: 0,
          object_name: "",
          write_date:null,
          apply_id:'',
          updaterList: [],
        }
      },
      methods: {
        handlePrint(){
          exportNotification({id:this.multipleSelection[0].id,write_date:this.write_date})
            .then(res => {
                let link = document.createElement('a')
                link.style.display = 'none'

                let blob = new Blob([res])
                link.href = URL.createObjectURL(blob)

                let ext_name = '.pdf'
                link.download = "船舶退会申请书" + ext_name
                document.body.appendChild(link)

                link.click()
                URL.revokeObjectURL(blob)
                document.body.removeChild(link)
                this.downloading = false
                this.dialogVisible = false
            })
            .catch(error => {
                this.downloading = false
                let reader = new FileReader()
                reader.onload = e => {
                  if (e.target.readyState === 2) {
                    let res = {}
                    res = JSON.parse(e.target.result)
                    this.$error_message(res)
                  }
                }
                reader.readAsText(error)
            })
        },
        handleSelectionChange(val) {
          this.multipleSelection = val;
        },
        loadData() {
          this.loading = true
          let p = []
          p.push(fetchFileTypeList({file_type: "bc|cc"}))

          Promise.all(p)
          .then(res => {
            this.file_type_list = res[0]
          })
          .catch(err => {
            this.loading = false
            this.$error_message(err)
          })
        },
        handleAppended(fileList) {
          this.$message({type: 'success', message: '文件上传成功!'})
        },
        handleUpload(row) {
          let customer_obj = {"id":row.customer,"name":row.name}
          this.customerList.push(customer_obj)
          this.apply_id = row.id
          this.object_name = row.name
          this.$refs.upload.handleOpen()
        },
        handleSubmit(row) {
            this.$confirm('提交审核后，将不能再修改, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              SubmitQuitApply({id: row.id})
              .then(res => {
                this.$message.success(res)
                this.getList()
              })
              .catch(err => {
                this.$error_message(err)
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              });          
            });
          },
        memberQuitApplyExport(){
          if (this.multipleSelection.length !== 1) {
                this.$error_message("请选择一条退会申请！")
                return
              }  
          this.dialogVisible = true

        },
       
        handleSuccess(row) {
            this.$router.push({ name: 'memberUpdate', query: {'type': 'SuccessQuitApply', 'id': row.id}})
            },
        setQueryStorage() {
            window.localStorage.setItem('query', JSON.stringify(this.query))
          },
        getCertStatusBadge,
        handleSearch() {
          this.getList()
        },
        handleUpdate(id) {
          this.setQueryStorage()
          this.$router.push({name: 'memberUpdate', query: {'type':'UpdateMember',id: id}})
        },
        handleDelete(customer) {
          var msg = '是否删除客户 ' + customer.name + ' ？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            deleteMember(customer.id)
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                this.getList()
              })
              .catch(error => {
                this.$message.error(error)
              })
          })
        },
        getList() {
          // 从数据库中加载用户数据
          this.listLoading = true
          getMemberList(this.query)
            .then(res => {
              this.list = res.results
              this.total = res.count
              this.listLoading = false
              window.localStorage.removeItem('query')
              this.$emit("toIndex", res.count)
            })
            .catch((error) => {
              this.listLoading = false
              this.$error_message(error)
            })
        },
        completeness(data) {
          var cn = 0
          var key_list = ['address', 'cert_number', 'cert_type', 'contact', 'contact_mobile', 
                      'email', 'mobile', 'name', 'phone', 'site']
          for (var key in data){
            if ((key_list.indexOf(key) > -1) && (data[key] !== null) && (data[key] !== "")) {
              cn += 1
            }
            else if (key == "ext_info"){
              var ext_info = data[key]
              for (var k in ext_info) {
                if (k == "tag_list") {
                  if (ext_info[k].length !== 0) {
                    cn += 1
                  }
                } else if ((ext_info[k] !== null) && (ext_info[k] !== "")) {
                  cn += 1
                }
              }
              // cn += Object.getOwnPropertyNames(data[key]).length - 1 
            }
          }
  
          var completeness = (cn / 10 * 100).toFixed(0)
          if (completeness > 100){ completeness = 100 }
          return completeness
        },
      },
      created() {
        this.query = JSON.parse(window.localStorage.getItem('query')) || {
            search: '',
            offset: 0,
            limit: 20,
            updater: '',
            type:'QuitApply'
            
          }
        this.getList()
        this.loadData()
      }
    }
  </script>
  